// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `boxx-custom-modal {
  background: var(--ion-color-primary, #7c7d7e);
  --boxx-modal-toolbar-background: #dfe0e3;
}

ion-title .toolbar-title {
  white-space: normal !important;
}

ion-icon {
  zoom: 0.7;
  padding-right: 4px;
}

.selected {
  color: var(--ion-color-warning);
}

.unselected {
  color: #dfe0e3;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/score-picker/score-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,wCAAA;AACF;;AAGE;EACE,8BAAA;AAAJ;;AAIA;EACE,SAAA;EACA,kBAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,cAAA;AADF","sourcesContent":["boxx-custom-modal {\n  background: var(--ion-color-primary, #7c7d7e);\n  --boxx-modal-toolbar-background: #dfe0e3;\n  //--boxx-modal-toolbar-margin-top: 0px;\n}\nion-title {\n  .toolbar-title {\n    white-space: normal !important;\n  }\n}\n\nion-icon {\n  zoom: 0.7;\n  padding-right: 4px;\n}\n\n.selected {\n  color: var(--ion-color-warning);\n}\n\n.unselected {\n  color: #dfe0e3;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
